export default __webpack_public_path__ + "static/media/matteozamagni.7098018e.webp";